import { createBrowserRouter } from "react-router-dom";
import Blogs from "../../pages/Blogs/Blogs";
import Home from "../../pages/Home/Home";
import Handmedown from "../../pages/Project/Handmedown";
import Passcomments from "../../pages/Project/Passcomments";
import Programmingsensei from "../../pages/Project/Programmingsensei";
import About from "../About/About";
import ContactMe from "../ContactMe/ContactMe";
import Main from "../Layout/Main";
import Projects from "../Projects/Projects";
import Services from "../Services/Services";
import Skills from "../Skills/Skills";

const router = createBrowserRouter([
    {
        path: '/',
        element: <Home></Home>
    },
    {
        path: '/',
        element: <Main></Main>,
        children: [
            {
                path: '/',
                element: <Home></Home>
            },
            {
                path: '/about',
                element: <About></About>
            },
            {
                path: '/skills',
                element: <Skills></Skills>
            },
            {
                path: '/projects',
                element: <Projects></Projects>
            },
            {
                path: '/services',
                element: <Services></Services>
            },
            {
                path: '/contact',
                element: <ContactMe></ContactMe>
            },
            {
                path: '/projects/01',
                element: <Handmedown></Handmedown>
            },
            {
                path: '/projects/02',
                element: <Passcomments></Passcomments>
            },
            {
                path: '/projects/03',
                element: <Programmingsensei></Programmingsensei>
            },
            {
                path: 'blogs',
                element: <Blogs></Blogs>
            },
        ]
    }
])

export default router;